module.exports = __webpack_public_path__ + "assets/img/social/reddit-icon.26a3984d6f1344d5dcd26bf2e3cfff36.svg";